module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0048.jpg?v=ddb180d8";